import { render } from "./new copy.vue?vue&type=template&id=4e827e8d&scoped=true"
import script from "./new copy.vue?vue&type=script&lang=js"
export * from "./new copy.vue?vue&type=script&lang=js"

import "./new copy.vue?vue&type=style&index=0&id=4e827e8d&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-agent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e827e8d"]])

export default __exports__